import { Button, Image, message, Input, Spin } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import {
  CheckOutlined
} from "@ant-design/icons";
import localization from '../../Localization/Localization.json'

import "./Checkout.scss";
import AddressModal from "../../components/AddressModal/AddressModal";
import { fallbackImg } from "../../constants/constants";
import { Link, withRouter } from "react-router-dom";
import { applycomment, PlaceOrder } from "../../network/cart.network";
import delv from "../../assets/delv.svg"
import offer_icon from "../../assets/offer_icon.svg" 
import { fetchCart } from "../../network/product.network";
import ResNavBar from "../../components/ResNavBar/ResNavBar";
import { clearCart } from "../../redux/cart/cart.action";
import { setAddressUser, setPaymentUser } from "../../redux/user/user.action";

class Checkout extends Component {
  state = {
    showModalVisible : false,
    commentLoading : false,
    orderLoading : false, 
    comment : "",
    loading : true,
    cart : null
  }

componentDidMount() {

  fetchCart((res) => {
    this.setState({loading : false, cart : res.data.data.cart}) 
  }, (error) => {
    this.setState({loading : false})
    console.log(error) 
  })
}

handelPromoCode = () => {
  this.setState({ commentLoading: true });
  setTimeout(() => {
    message.success(localization.commentsavedsuccessfully[this.props.currentLang]);
    this.setState({ commentLoading: false }); 
  }, 500)
}

  // handelPromoCode = () => {
  //   const { comment } = this.state;
  //   this.setState({ commentLoading: true });
  //   let body = new FormData();
  //   body.append("comment", comment);
  //   applycomment( 
  //     body,
  //     (res) => {
  //       this.setState({ commentLoading: false });
  //       if (res.data.code === 200) {
  //         message.success(res.data.message);
  //       }
  //     },
  //     (error) => {
  //       this.setState({ commentLoading: false });
  //       console.log(error); 
  //     }
  //   );
  // };

  handelPlaceOrder = () => {
    const { comment } = this.state;
    console.log(comment); 
    this.setState({ orderLoading: true });
    let body = new FormData();
    body.append("comment", comment);
    PlaceOrder(  
      body,
      (res) => {
        this.setState({ orderLoading: false });
        if (res.data.code === 200) {
          message.success(res.data.message);
          this.props.dispatch(clearCart());
          this.props.dispatch(setAddressUser(null))  
          this.props.dispatch(setPaymentUser(null))  

          setTimeout(() => {
            this.props.history.push({
              pathname: '/order-placed',
              state: { orderID : res.data.item } 
            });  
        }, 500)
        }
      },
      (error) => {
        this.setState({ orderLoading: false });
        console.log(error); 
      }
    );
  };

  render() {
    const {showModalVisible, commentLoading, loading, cart, orderLoading} = this.state; 
    const {currentLang, currentAddress} = this.props;
    return (
      <div className="checkout-page-wrapper"> 
        <Header />
        <AddressModal closeModal={() => this.setState({showModalVisible : false}) } showModalVisible={showModalVisible} />
        <div className="container">
          <Spin spinning={loading}>
          <div className="checkout-content-wrapper">
            <div className="checkout-main">
              <div className="checkout-header">
                <p>{localization.OrderSummary[currentLang]}</p> 
                <Button loading={orderLoading} size="large" type="primary" onClick={this.handelPlaceOrder}> 
                  {/* <Link to="/checkout"> */}
                  {localization.PlaceOrder[currentLang]}
                  {/* </Link> */}
                  </Button>
              </div>
              {
                cart?.totals?.promoCode && 
                <div className="saved-holder"> 
                <p><img src={offer_icon} alt="" /> {localization.Yousaved[currentLang]} <span>{cart?.totals?.discount} {localization.AED[currentLang]} </span> {localization.throughoffers[currentLang]} </p>
              </div>
              }
              <div className="checkout-items-holder">
                <p className="checkout-items-title">{localization.Items[currentLang]}</p> 
                <div className="checkout-items-list">
                  {cart?.items?.map(card => 
                  <div className="item-holder" key={card.id}>
                  <div className="product-img">
                    <Image
                      src={card?.image_link || card?.image || fallbackImg}
                      fallback={fallbackImg}
                      preview={false}
                      />
                  </div>
                  <div className="product-details-wrapper">
                  <div className="product-info">
                    <h6 className="product-name">{card?.productName || card?.name}</h6> 
                    <span className="product-count">x{card.quantity}</span> 
                  </div>

                  <div className="price-holder">
                    <p className="price-after">
                      {card?.price} <span>{localization.AED[currentLang]}</span> 
                    </p>
                    {/* {card?.discount_price && (
                      <p className="price-before">{card?.price} {localization.AED[currentLang]}</p>
                    )} */}
                  </div>
                  </div>
                  </div>
                  )}
                </div>

                <div className="cart-aside-card">
                  <h6 className="cart-aside-card--title">{localization.Deliverto[currentLang]}</h6>
                  {currentAddress ? 
                  <div className="aside-card-row"> 
                    <h4 className="card-row-title"> 
                          {currentAddress.city_name + ", Street No. " + currentAddress.street_number + ", floor " + currentAddress.floor + "," + currentAddress.landmark }  
                          { ", " + currentAddress.note && currentAddress.note}   
                      </h4> 
                    <p className="card-row-btn" onClick={() => this.setState({showModalVisible : true}) }>{localization.CHange[currentLang]}</p>
                  </div>
                    : 
                  <div className="aside-card-row">
                    <p className="card-row-btn" onClick={() => this.setState({showModalVisible : true}) }>select Address</p> 
                  </div>} 
                </div>

                <div className="cart-aside-promo">
                  <div className="cart-aside-promo--header">
                      <h6 className="promo--title">{localization.Generalcomment[currentLang]}</h6> 
                  </div>
                  <div className="promo-apply">
                  <Input placeholder={localization.Leavecomment[currentLang]} onChange={(e) => this.setState({comment : e.target.value}) } /> 
                  <Button size="large" type="primary" onClick={this.handelPromoCode} loading={commentLoading}>{localization.Send[currentLang]}</Button>
                  </div> 
                </div>

                <p className="order-deliver-holder">
                  <img src={delv} alt="" /> 
                  {localization.ETA[currentLang]} 
                </p>

              </div>

              <div className="checkout-total-holder">
                    <div className="total-row">
                      <h4>{localization.Subtotal[currentLang]}</h4> 
                      <h5>{cart?.totals?.subtotal}<span>{localization.AED[currentLang]}</span></h5>
                    </div>
                    {cart?.totals?.promoCode &&
                    <div className="total-row">
                      <h4>{localization.Discount[currentLang]}<span>({localization.Promocodeapplied[currentLang]})</span> </h4>
                      <h5>{parseFloat(+cart?.totals?.discountPercentage).toFixed(0)}%</h5>   
                    </div>
                    }
              </div>  

              <div className="checkout-final-total"> 
              <div className="total-row"> 
                      <h4>{localization.TOTAL[currentLang]}</h4>
                      <h5>{cart?.totals?.total}<span>{localization.AED[currentLang]}</span></h5>
                    </div>
                </div>    

            </div>
          </div>
          </Spin>
        </div>
        <Footer />
        <ResNavBar /> 
      </div>
    );
  }
}

const CheckoutWithRouter = withRouter(Checkout); 
const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang,
  currentAddress : state.user.currentAddress,
});

export default connect(mapStateToProps)(CheckoutWithRouter); 
